import { ContentBody } from '@databases/types/confluence';
import { logError } from '@databases/utils/utils';

const RequestURI = '/wiki/rest/api/contentbody/convert/export_view';

export const excerptLoad = async (
  spaceKey: string,
  contentTitle: string
): Promise<ContentBody> => {
  const body = {
    value: `<ac:structured-macro ac:name="excerpt-include"><ac:parameter ac:name=""><ac:link><ri:page ri:space-key="${spaceKey}" ri:content-title="${contentTitle}"/></ac:link></ac:parameter></ac:structured-macro>`,
    representation: 'storage',
  };

  const response = await fetch(RequestURI, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    logError(new Error(`Response status: ${response.status}`));
  }

  return await response.json();
};
